import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d3c1f2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "workflow-page" }
const _hoisted_2 = { class: "workflow-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Quản lý thực hiện dịch vụ"),
  /*#__PURE__*/_createElementVNode("p", null, "Duyệt dịch vụ theo khoa/phòng trước khi phân công và chia lịch.")
], -1))
const _hoisted_4 = { class: "workflow-scope" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "khoa-lam-viec" }, "Khoa/phòng đang làm việc", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Chọn khoa/phòng để bắt đầu. Dữ liệu cấu hình và chia lịch chỉ áp dụng cho khoa/phòng đang chọn.")
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Khoa/phòng chưa có dịch vụ được duyệt. Hãy chọn dịch vụ ở bước 1; hệ thống sẽ không tự lấy toàn bộ danh mục HIS để chia lịch.")
const _hoisted_9 = { class: "delete-all-toolbar" }
const _hoisted_10 = { class: "p-fluid" }
const _hoisted_11 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_12 = { class: "p-field p-col p-col-12 p-md-4" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Nhóm dịch vụ", -1))
const _hoisted_14 = { class: "p-field p-col p-col-12 p-md-4" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn nhanh", -1))
const _hoisted_16 = { class: "check-row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "chonTatCaDichVu" }, "Chọn tất cả trong nhóm", -1))
const _hoisted_18 = { class: "p-field p-col p-col-12 p-md-4" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Dịch vụ đã chọn", -1))
const _hoisted_20 = {
  class: "p-inputtext",
  style: {"height":"38px","display":"flex","align-items":"center"}
}
const _hoisted_21 = {
  key: 0,
  class: "p-field p-col-12 p-md-12"
}
const _hoisted_22 = { style: {"display":"flex","justify-content":"space-between","gap":"12px","align-items":"center","flex-wrap":"wrap"} }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Chọn dịch vụ trong bảng", -1))
const _hoisted_24 = {
  class: "p-input-icon-left",
  style: {"min-width":"300px"}
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Không còn dịch vụ chưa cấu hình trong nhóm này.")
const _hoisted_27 = { class: "p-field p-col p-col-12 p-md-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Số thực hiện", -1))
const _hoisted_29 = { class: "p-field p-col p-col-12 p-md-3" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "BN nghỉ tối thiểu sau dịch vụ (phút)", -1))
const _hoisted_31 = {
  key: 1,
  class: "p-field p-col p-col-12 p-md-3"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Thêm", -1))
const _hoisted_33 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Không có thông tin danh sách dịch vụ. ")
const _hoisted_35 = { class: "delete-all-toolbar" }
const _hoisted_36 = { class: "p-fluid" }
const _hoisted_37 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_38 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn khoa/phòng", -1))
const _hoisted_40 = { class: "p-field p-col-12" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn nhân viên để thêm vào khoa/phòng", -1))
const _hoisted_42 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Thêm", -1))
const _hoisted_44 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" Không có thông tin danh sách nhân viên. ")
const _hoisted_46 = { class: "delete-all-toolbar" }
const _hoisted_47 = { class: "p-fluid" }
const _hoisted_48 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_49 = { class: "p-field p-col p-col-12 p-md-6 p-lg-4" }
const _hoisted_50 = { class: "p-fluid" }
const _hoisted_51 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_52 = { class: "p-field p-col p-col-12 p-md-8 p-lg-8" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Tên nhóm", -1))
const _hoisted_54 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Thêm", -1))
const _hoisted_56 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Không có thông tin danh sách nhóm. ")
const _hoisted_58 = { class: "p-field p-col p-col-12 p-md-6 p-lg-8" }
const _hoisted_59 = { class: "equipment-workspace" }
const _hoisted_60 = { class: "p-fluid" }
const _hoisted_61 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_62 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_63 = { class: "p-fluid" }
const _hoisted_64 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_65 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn nhóm thiết bị", -1))
const _hoisted_67 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn khoa/phòng", -1))
const _hoisted_69 = { class: "p-field p-col-12" }
const _hoisted_70 = /*#__PURE__*/_createTextVNode("Chọn khoa/phòng và nhóm thiết bị, sau đó tích chọn thiết bị trong bảng.")
const _hoisted_71 = /*#__PURE__*/_createTextVNode("Không có thiết bị chưa gán vào khoa/phòng này.")
const _hoisted_72 = {
  key: 0,
  class: "p-field p-col-12"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Thêm", -1))
const _hoisted_74 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_75 = /*#__PURE__*/_createTextVNode(" Không có thiết bị trong nhóm. ")
const _hoisted_76 = { class: "p-fluid" }
const _hoisted_77 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_78 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_79 = { class: "delete-all-toolbar" }
const _hoisted_80 = { class: "p-fluid" }
const _hoisted_81 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_82 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn khoa/phòng", -1))
const _hoisted_84 = { class: "p-field p-col-12" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn nhân viên", -1))
const _hoisted_86 = { class: "p-field p-col-12" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn dịch vụ", -1))
const _hoisted_88 = { class: "p-field p-col-12" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Thêm", -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Các ô chọn phía trên dùng để thêm phân công. Bảng bên dưới là dữ liệu đã lưu trong cơ sở dữ liệu.", -1))
const _hoisted_91 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_92 = /*#__PURE__*/_createTextVNode(" Không có thông tin. ")
const _hoisted_93 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_94 = { class: "delete-all-toolbar" }
const _hoisted_95 = /*#__PURE__*/_createTextVNode("Chọn nhân viên phụ và dịch vụ, sau đó bấm Áp dụng để lưu. Dịch vụ đã phân công người phụ chỉ được xếp khi có cả người chính và người phụ khác nhau cùng rảnh, cùng có mặt.")
const _hoisted_96 = { class: "p-fluid" }
const _hoisted_97 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_98 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn khoa/phòng", -1))
const _hoisted_100 = { class: "p-field p-col-12" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn nhân viên", -1))
const _hoisted_102 = { class: "p-field p-col-12" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn dịch vụ", -1))
const _hoisted_104 = { class: "p-field p-col-12" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Thêm", -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Các ô chọn phía trên dùng để thêm phân công. Bảng bên dưới là dữ liệu đã lưu trong cơ sở dữ liệu.", -1))
const _hoisted_107 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_108 = /*#__PURE__*/_createTextVNode(" Không có thông tin. ")
const _hoisted_109 = { class: "p-field p-col-12" }
const _hoisted_110 = { class: "delete-all-toolbar" }
const _hoisted_111 = { class: "p-fluid" }
const _hoisted_112 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_113 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn nhóm thiết bị", -1))
const _hoisted_115 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-4 p-lg-4"
}
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn khoa phòng", -1))
const _hoisted_117 = {
  key: 1,
  class: "p-field p-col p-col-12 p-md-4 p-lg-4"
}
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn thiết bị", -1))
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Áp dụng toàn bộ nhóm thiết bị nội bộ (kể cả thiết bị thêm sau)", -1))
const _hoisted_120 = {
  key: 2,
  class: "p-field p-col-12"
}
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn dịch vụ", -1))
const _hoisted_122 = {
  key: 3,
  class: "p-field p-col-12"
}
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Thêm", -1))
const _hoisted_124 = /*#__PURE__*/_createTextVNode("Chưa có nhóm thiết bị áp dụng cho dịch vụ.")
const _hoisted_125 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_126 = /*#__PURE__*/_createTextVNode(" Không có thông tin. ")
const _hoisted_127 = { class: "p-fluid" }
const _hoisted_128 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_129 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn khoa/phòng", -1))
const _hoisted_131 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn ngày thực hiện: ", -1))
const _hoisted_133 = { class: "p-field p-col p-col-12 p-md-2 p-lg-2" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chia lịch", -1))
const _hoisted_135 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_136 = { style: {"display":"flex","align-items":"center","gap":"12px","flex-wrap":"wrap"} }
const _hoisted_137 = { key: 0 }
const _hoisted_138 = { style: {"margin-left":"8px"} }
const _hoisted_139 = { style: {"margin-left":"8px"} }
const _hoisted_140 = /*#__PURE__*/_createTextVNode(" Không có thông tin nhân viên. ")
const _hoisted_141 = {
  key: 0,
  class: "p-field p-col-12 p-md-12"
}
const _hoisted_142 = { class: "result-toolbar" }
const _hoisted_143 = /*#__PURE__*/_createTextVNode(" Khoa/phòng chưa lưu phân công thủ thuật viên phụ nên lịch hiện tại chưa có người phụ. ")
const _hoisted_144 = { key: 0 }
const _hoisted_145 = { key: 0 }
const _hoisted_146 = { key: 1 }
const _hoisted_147 = /*#__PURE__*/_createTextVNode("Không có chỉ định được xếp lịch.")
const _hoisted_148 = { class: "p-field p-col-12" }
const _hoisted_149 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_150 = { id: "loadingExport" }
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Đang tải dữ liệu, vui lòng chờ...", -1))
const _hoisted_152 = { class: "p-fluid" }
const _hoisted_153 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_154 = { class: "p-field p-col p-col-12 p-md-8 p-lg-8" }
const _hoisted_155 = { class: "flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_BangChon = _resolveComponent("BangChon")!
  const _component_NhomDichVuNoiBo = _resolveComponent("NhomDichVuNoiBo")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_BangLichNhanVien = _resolveComponent("BangLichNhanVien")!
  const _component_KhungChiTiet = _resolveComponent("KhungChiTiet")!
  const _component_LichSuChiaGio = _resolveComponent("LichSuChiaGio")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_Dropdown, {
          inputId: "khoa-lam-viec",
          modelValue: $setup.khoaLamViec,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.khoaLamViec) = $event)),
          options: $setup.listKhoaPhong,
          optionLabel: "tenPhongBan",
          optionValue: "phongBan_Id",
          placeholder: "Chọn khoa/phòng",
          filter: true,
          disabled: $setup.dangLuuDichVu || $setup.dangLuuCauHinh || $setup.dangGanThietBi || $setup.loadingExport || $setup.loadingChamCong
        }, null, 8, ["modelValue", "options", "disabled"]),
        _createElementVNode("span", null, _toDisplayString($setup.listDichVu.length) + " dịch vụ đã duyệt", 1)
      ])
    ]),
    (!$setup.khoaLamViec)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          severity: "info",
          closable: false
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (!$setup.dangTaiDichVuKhoa && !$setup.listDichVu.length)
            ? (_openBlock(), _createBlock(_component_Message, {
                key: 0,
                severity: "warn",
                closable: false
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_TabView, {
            activeIndex: $setup.buocDangMo,
            "onUpdate:activeIndex": _cache[77] || (_cache[77] = ($event: any) => (($setup.buocDangMo) = $event))
          }, {
            default: _withCtx(() => [
              ($setup.isLoggedIn)
                ? (_openBlock(), _createBlock(_component_TabPanel, {
                    key: 0,
                    header: "1. Dịch vụ được duyệt"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_Button, {
                          label: "Xóa tất cả dịch vụ đã duyệt",
                          icon: "pi pi-trash",
                          class: "p-button-danger p-button-outlined",
                          disabled: !$setup.khoaLamViec || $setup.dangXoaTatCa || $setup.dangLuuDichVu || $setup.dangLuuCauHinh,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.xacNhanXoaTatCa('dichVu')))
                        }, null, 8, ["disabled"])
                      ]),
                      _createVNode(_component_Panel, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _hoisted_13,
                                _createVNode(_component_Dropdown, {
                                  modelValue: $setup.nhomDichVuSelect,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.nhomDichVuSelect) = $event)),
                                  options: $setup.listNhomDichVu,
                                  optionLabel: "tenNhomDichVu",
                                  optionValue: "nhomDichVu_Id",
                                  loading: $setup.dangTaiDanhMucDuyet,
                                  placeholder: "Chọn nhóm",
                                  filter: true,
                                  disabled: $setup.dangLuuDichVu,
                                  onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.locDichVuTheoNhom()))
                                }, null, 8, ["modelValue", "options", "loading", "disabled"])
                              ]),
                              _createElementVNode("div", _hoisted_14, [
                                _hoisted_15,
                                _createElementVNode("div", _hoisted_16, [
                                  _createVNode(_component_Checkbox, {
                                    modelValue: $setup.chonTatCaDichVu,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.chonTatCaDichVu) = $event)),
                                    binary: true,
                                    inputId: "chonTatCaDichVu",
                                    onChange: _cache[5] || (_cache[5] = ($event: any) => ($setup.chonCaNhom())),
                                    disabled: !$setup.nhomDichVuSelect || $setup.dangLuuDichVu
                                  }, null, 8, ["modelValue", "disabled"]),
                                  _hoisted_17
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_18, [
                                _hoisted_19,
                                _createElementVNode("div", _hoisted_20, _toDisplayString($setup.soDichVuDaChon) + " / " + _toDisplayString($setup.listDichVuTheoNhom.length) + " dịch vụ chưa cấu hình ", 1)
                              ]),
                              ($setup.nhomDichVuSelect)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    ($setup.chonTatCaDichVu)
                                      ? (_openBlock(), _createBlock(_component_DataTable, {
                                          key: 0,
                                          value: $setup.dongChonTatCa,
                                          showGridlines: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Column, {
                                              field: "tenDichVu",
                                              header: "Phạm vi đã chọn"
                                            }),
                                            _createVNode(_component_Column, {
                                              field: "soLuong",
                                              header: "Số dịch vụ mới"
                                            }),
                                            _createVNode(_component_Column, { header: "Thao tác" }, {
                                              body: _withCtx(() => [
                                                _createVNode(_component_Button, {
                                                  label: "Chọn từng dịch vụ",
                                                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.boChonTatCa()))
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["value"]))
                                      : (_openBlock(), _createBlock(_component_DataTable, {
                                          key: 1,
                                          value: $setup.listDichVuTheoNhom,
                                          selection: $setup.dichVuDaChon,
                                          "onUpdate:selection": _cache[8] || (_cache[8] = ($event: any) => (($setup.dichVuDaChon) = $event)),
                                          filters: $setup.boLocDichVuChon,
                                          "onUpdate:filters": _cache[9] || (_cache[9] = ($event: any) => (($setup.boLocDichVuChon) = $event)),
                                          dataKey: "dichVu_Id",
                                          paginator: true,
                                          rows: 10,
                                          rowsPerPageOptions: [10, 20, 50],
                                          globalFilterFields: ['tenDichVu', 'dichVu_Id'],
                                          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                                          currentPageReportTemplate: "Hiển thị {first}-{last} / {totalRecords} dịch vụ",
                                          stripedRows: "",
                                          showGridlines: "",
                                          responsiveLayout: "scroll"
                                        }, {
                                          header: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_22, [
                                              _hoisted_23,
                                              _createElementVNode("span", _hoisted_24, [
                                                _hoisted_25,
                                                _createVNode(_component_InputText, {
                                                  modelValue: $setup.boLocDichVuChon['global'].value,
                                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.boLocDichVuChon['global'].value) = $event)),
                                                  placeholder: "Tìm tên hoặc mã dịch vụ",
                                                  style: {"width":"100%"}
                                                }, null, 8, ["modelValue"])
                                              ])
                                            ])
                                          ]),
                                          empty: _withCtx(() => [
                                            _hoisted_26
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_Column, {
                                              selectionMode: "multiple",
                                              headerStyle: "width: 3rem"
                                            }),
                                            _createVNode(_component_Column, {
                                              field: "dichVu_Id",
                                              header: "Mã ID",
                                              sortable: "",
                                              headerStyle: "width: 8rem"
                                            }),
                                            _createVNode(_component_Column, {
                                              field: "tenDichVu",
                                              header: "Tên dịch vụ",
                                              sortable: ""
                                            }),
                                            _createVNode(_component_Column, {
                                              field: "tenNhomDichVu",
                                              header: "Nhóm dịch vụ",
                                              sortable: ""
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["value", "selection", "filters"]))
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_27, [
                                _hoisted_28,
                                _createVNode(_component_InputNumber, {
                                  modelValue: $setup.dichVu.soThucHien,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.dichVu.soThucHien) = $event)),
                                  min: 1
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_29, [
                                _hoisted_30,
                                _createVNode(_component_InputNumber, {
                                  modelValue: $setup.dichVu.thoiGianNghi,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.dichVu.thoiGianNghi) = $event)),
                                  min: 0
                                }, null, 8, ["modelValue"])
                              ]),
                              ($setup.soDichVuDaChon)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _hoisted_32,
                                    _createVNode(_component_Button, {
                                      label: 'Duyệt ' + $setup.soDichVuDaChon + ' dịch vụ cho khoa/phòng',
                                      icon: "pi pi-check",
                                      onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.createNhieuDichVu())),
                                      loading: $setup.dangLuuDichVu,
                                      disabled: $setup.dangLuuDichVu || !$setup.khoaLamViec
                                    }, null, 8, ["label", "loading", "disabled"])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_33, [
                                _createVNode(_component_DataTable, {
                                  value: $setup.bangDichVu,
                                  paginator: true,
                                  stripedRows: "",
                                  showGridlines: "",
                                  rows: 40,
                                  rowsPerPageOptions: [10,25,50],
                                  rowHover: true,
                                  paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                                  globalFilterFields: ['tenDichVu','maDichVu','dichVu_Id'],
                                  currentPageReportTemplate: "Có tất cả {totalRecords} dòng cấu hình",
                                  filters: $setup.filters,
                                  "onUpdate:filters": _cache[13] || (_cache[13] = ($event: any) => (($setup.filters) = $event)),
                                  style: {"font-size":"14px"}
                                }, {
                                  empty: _withCtx(() => [
                                    _hoisted_34
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_Column, {
                                      field: "tenDichVu",
                                      header: "Dịch vụ",
                                      sortable: ""
                                    }),
                                    _createVNode(_component_Column, {
                                      field: "tenNhomDichVu",
                                      header: "Nhóm dịch vụ",
                                      sortable: ""
                                    }),
                                    _createVNode(_component_Column, {
                                      field: "soLuong",
                                      header: "Số dịch vụ"
                                    }),
                                    _createVNode(_component_Column, {
                                      field: "soThucHien",
                                      header: "Số thực hiện"
                                    }, {
                                      body: _withCtx((slotProps) => [
                                        _createVNode(_component_InputNumber, {
                                          modelValue: slotProps.data.soThucHien,
                                          "onUpdate:modelValue": ($event: any) => ((slotProps.data.soThucHien) = $event),
                                          min: 1,
                                          placeholder: "Khác nhau"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Column, {
                                      field: "thoiGianNghi",
                                      header: "BN nghỉ tối thiểu (phút)"
                                    }, {
                                      body: _withCtx((slotProps) => [
                                        _createVNode(_component_InputNumber, {
                                          modelValue: slotProps.data.thoiGianNghi,
                                          "onUpdate:modelValue": ($event: any) => ((slotProps.data.thoiGianNghi) = $event),
                                          min: 0,
                                          placeholder: "Khác nhau"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Column, { header: "Lưu" }, {
                                      body: _withCtx((slotProps) => [
                                        _createVNode(_component_Button, {
                                          icon: "pi pi-save",
                                          label: slotProps.data.laCaNhom ? 'Lưu cả nhóm' : 'Lưu',
                                          onClick: ($event: any) => ($setup.updateDichVu(slotProps.data)),
                                          disabled: $setup.dangLuuDichVu
                                        }, null, 8, ["label", "onClick", "disabled"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Column, {
                                      field: "id",
                                      header: "Thao tác"
                                    }, {
                                      body: _withCtx((slotProps) => [
                                        (slotProps.data.laCaNhom)
                                          ? (_openBlock(), _createBlock(_component_Button, {
                                              key: 0,
                                              label: "Xem chi tiết",
                                              onClick: ($event: any) => ($setup.moNhomDichVu(slotProps.data.nhomDichVu_Id))
                                            }, null, 8, ["onClick"]))
                                          : (_openBlock(), _createBlock(_component_Button, {
                                              key: 1,
                                              label: "Bỏ duyệt",
                                              icon: "pi pi-trash",
                                              iconPos: "left",
                                              onClick: ($event: any) => ($setup.boDuyetDichVu(slotProps.data.dichVu_Id)),
                                              severity: "danger",
                                              raised: ""
                                            }, null, 8, ["onClick"]))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value", "filters"]),
                                ($setup.nhomDichVuDangMo.length)
                                  ? (_openBlock(), _createBlock(_component_Button, {
                                      key: 0,
                                      label: "Thu gọn các nhóm",
                                      style: {"margin-top":"8px","max-width":"220px"},
                                      onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.nhomDichVuDangMo = []))
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ($setup.isLoggedIn)
                ? (_openBlock(), _createBlock(_component_TabPanel, {
                    key: 1,
                    header: "2. Nhân viên khoa/phòng"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_Button, {
                          label: "Xóa tất cả nhân viên khỏi khoa",
                          icon: "pi pi-trash",
                          class: "p-button-danger p-button-outlined",
                          disabled: !$setup.khoaLamViec || $setup.dangXoaTatCa || $setup.dangLuuCauHinh,
                          onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.xacNhanXoaTatCa('nhanVien')))
                        }, null, 8, ["disabled"])
                      ]),
                      _createVNode(_component_Panel, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _hoisted_39,
                                _createVNode(_component_InputText, {
                                  modelValue: $setup.tenKhoaLamViec,
                                  readonly: "",
                                  class: "scope-readonly"
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_40, [
                                _hoisted_41,
                                _createVNode(_component_BangChon, {
                                  modelValue: $setup.nhanVienKhoaIds,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.nhanVienKhoaIds) = $event)),
                                  options: $setup.listNhanVienVltl,
                                  labelField: "userName",
                                  valueField: "userId",
                                  danhTu: "nhân viên",
                                  disabled: $setup.dangLuuCauHinh
                                }, null, 8, ["modelValue", "options", "disabled"])
                              ]),
                              _createElementVNode("div", _hoisted_42, [
                                _hoisted_43,
                                _createVNode(_component_Button, {
                                  label: "Thêm nhân viên đã chọn",
                                  icon: "pi pi-plus-circle",
                                  onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.themNhanVienHangLoat())),
                                  disabled: !$setup.nhanVienKhoaPhong.idKhoaPhong || !$setup.nhanVienKhoaIds.length || $setup.dangLuuCauHinh
                                }, null, 8, ["disabled"])
                              ]),
                              _createElementVNode("div", _hoisted_44, [
                                _createVNode(_component_DataTable, {
                                  value: $setup.listNhanVienKhoaPhong.filter(x => x.idKhoaPhong === $setup.khoaLamViec),
                                  paginator: true,
                                  stripedRows: "",
                                  showGridlines: "",
                                  rows: 40,
                                  rowsPerPageOptions: [10,25,50],
                                  rowHover: true,
                                  paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                                  globalFilterFields: ['tenNhanVien','khoaPhong'],
                                  currentPageReportTemplate: "Có tất cả {totalRecords} nhân viên",
                                  filters: $setup.filters,
                                  "onUpdate:filters": _cache[18] || (_cache[18] = ($event: any) => (($setup.filters) = $event)),
                                  style: {"font-size":"14px"}
                                }, {
                                  empty: _withCtx(() => [
                                    _hoisted_45
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_Column, {
                                      field: "tenNhanVien",
                                      header: "Tên nhân viên",
                                      sortable: ""
                                    }),
                                    _createVNode(_component_Column, {
                                      field: "nhanVien_Id",
                                      header: "Nhân viên Id",
                                      sortable: ""
                                    }),
                                    _createVNode(_component_Column, {
                                      field: "khoaPhong",
                                      header: "Khoa Phòng",
                                      sortable: ""
                                    }),
                                    _createVNode(_component_Column, {
                                      field: "idKhoaPhong",
                                      header: "Khoa Phòng Id",
                                      sortable: ""
                                    }),
                                    _createVNode(_component_Column, {
                                      field: "id",
                                      header: "Xóa nhân viên"
                                    }, {
                                      body: _withCtx((slotProps) => [
                                        _createVNode(_component_Button, {
                                          label: "Xóa",
                                          icon: "pi pi-trash",
                                          iconPos: "left",
                                          onClick: ($event: any) => ($setup.deleteNhanVienKhoaPhong(slotProps.data.id)),
                                          severity: "danger",
                                          raised: ""
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value", "filters"])
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ($setup.isLoggedIn)
                ? (_openBlock(), _createBlock(_component_TabPanel, {
                    key: 2,
                    header: "3. Thiết bị khoa/phòng"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_Button, {
                          label: "Xóa tất cả thiết bị khỏi khoa",
                          icon: "pi pi-trash",
                          class: "p-button-danger p-button-outlined",
                          disabled: !$setup.khoaLamViec || $setup.dangXoaTatCa || $setup.dangLuuCauHinh || $setup.dangGanThietBi,
                          onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.xacNhanXoaTatCa('thietBi')))
                        }, null, 8, ["disabled"])
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _createVNode(_component_Panel, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_50, [
                                  _createElementVNode("div", _hoisted_51, [
                                    _createElementVNode("div", _hoisted_52, [
                                      _hoisted_53,
                                      _createVNode(_component_InputText, {
                                        id: "nhomThietBi",
                                        type: "text",
                                        modelValue: $setup.nhomThietBi.tenNhomThietBi,
                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.nhomThietBi.tenNhomThietBi) = $event)),
                                        placeholder: "Tên nhóm"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_54, [
                                      _hoisted_55,
                                      _createVNode(_component_Button, {
                                        label: "Thêm",
                                        icon: "pi pi-plus-circle",
                                        iconPos: "left",
                                        onClick: _cache[21] || (_cache[21] = ($event: any) => ($setup.createNhomThietBi()))
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_56, [
                                      _createVNode(_component_DataTable, {
                                        value: $setup.listNhomThietBi,
                                        paginator: true,
                                        stripedRows: "",
                                        showGridlines: "",
                                        rows: 40,
                                        rowsPerPageOptions: [10,25,50],
                                        rowHover: true,
                                        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                                        globalFilterFields: ['tenNhomThietBi'],
                                        currentPageReportTemplate: "Có tất cả {totalRecords} nhóm",
                                        filters: $setup.filters,
                                        "onUpdate:filters": _cache[22] || (_cache[22] = ($event: any) => (($setup.filters) = $event)),
                                        style: {"font-size":"14px"}
                                      }, {
                                        empty: _withCtx(() => [
                                          _hoisted_57
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            field: "tenNhomThietBi",
                                            header: "Tên nhóm",
                                            sortable: ""
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["value", "filters"])
                                    ])
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("div", _hoisted_60, [
                                _createElementVNode("div", _hoisted_61, [
                                  _createElementVNode("div", _hoisted_62, [
                                    _createVNode(_component_Panel, { header: "Chọn thiết bị HIS để thêm vào khoa/phòng" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_63, [
                                          _createElementVNode("div", _hoisted_64, [
                                            _createElementVNode("div", _hoisted_65, [
                                              _hoisted_66,
                                              _createVNode(_component_Dropdown, {
                                                modelValue: $setup.thietBi.idNhomThietBi,
                                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($setup.thietBi.idNhomThietBi) = $event)),
                                                options: $setup.listNhomThietBi,
                                                optionLabel: "tenNhomThietBi",
                                                optionValue: "id",
                                                placeholder: "Chọn nhóm thiết bị",
                                                filter: true,
                                                style: {"height":"35px"},
                                                disabled: $setup.dangGanThietBi
                                              }, null, 8, ["modelValue", "options", "disabled"])
                                            ]),
                                            _createElementVNode("div", _hoisted_67, [
                                              _hoisted_68,
                                              _createVNode(_component_InputText, {
                                                modelValue: $setup.tenKhoaLamViec,
                                                readonly: "",
                                                class: "scope-readonly"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _createElementVNode("div", _hoisted_69, [
                                              _createVNode(_component_Button, {
                                                label: "Tải danh mục thiết bị HIS",
                                                icon: "pi pi-refresh",
                                                onClick: _cache[24] || (_cache[24] = ($event: any) => ($setup.taiDanhMucThietBi())),
                                                loading: $setup.dangTaiDanhMucThietBi,
                                                disabled: $setup.dangGanThietBi
                                              }, null, 8, ["loading", "disabled"]),
                                              (!$setup.thietBi.idKhoaPhong)
                                                ? (_openBlock(), _createBlock(_component_Message, {
                                                    key: 0,
                                                    severity: "info",
                                                    closable: false
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_70
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true),
                                              ($setup.thietBi.idKhoaPhong)
                                                ? (_openBlock(), _createBlock(_component_DataTable, {
                                                    key: 1,
                                                    value: $setup.thietBiChuaGan,
                                                    selection: $setup.thietBiDaChon,
                                                    "onUpdate:selection": _cache[28] || (_cache[28] = ($event: any) => (($setup.thietBiDaChon) = $event)),
                                                    dataKey: "thietBi_Id",
                                                    paginator: true,
                                                    rows: 10,
                                                    rowsPerPageOptions: [10,20,50],
                                                    filters: $setup.boLocThietBiHis,
                                                    "onUpdate:filters": _cache[29] || (_cache[29] = ($event: any) => (($setup.boLocThietBiHis) = $event)),
                                                    globalFilterFields: ['tenThietBi','maThietBi','thietBi_Id'],
                                                    loading: $setup.dangTaiDanhMucThietBi || $setup.dangTaiThietBiKhoa,
                                                    stripedRows: "",
                                                    showGridlines: "",
                                                    currentPageReportTemplate: "{first}-{last} / {totalRecords} thiết bị chưa gán"
                                                  }, {
                                                    header: _withCtx(() => [
                                                      _createVNode(_component_Button, {
                                                        label: "Chọn tất cả",
                                                        onClick: _cache[25] || (_cache[25] = ($event: any) => ($setup.thietBiDaChon = [...$setup.thietBiChuaGan])),
                                                        disabled: $setup.dangGanThietBi
                                                      }, null, 8, ["disabled"]),
                                                      _createVNode(_component_Button, {
                                                        label: "Bỏ chọn tất cả",
                                                        onClick: _cache[26] || (_cache[26] = ($event: any) => ($setup.thietBiDaChon = [])),
                                                        disabled: $setup.dangGanThietBi
                                                      }, null, 8, ["disabled"]),
                                                      _createVNode(_component_InputText, {
                                                        modelValue: $setup.boLocThietBiHis.global.value,
                                                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.boLocThietBiHis.global.value) = $event)),
                                                        placeholder: "Tìm tên, mã hoặc ID thiết bị"
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    empty: _withCtx(() => [
                                                      _hoisted_71
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Column, {
                                                        selectionMode: "multiple",
                                                        headerStyle: "width:3rem"
                                                      }),
                                                      _createVNode(_component_Column, {
                                                        field: "thietBi_Id",
                                                        header: "ID HIS",
                                                        sortable: ""
                                                      }),
                                                      _createVNode(_component_Column, {
                                                        field: "maThietBi",
                                                        header: "Mã thiết bị",
                                                        sortable: ""
                                                      }),
                                                      _createVNode(_component_Column, {
                                                        field: "tenThietBi",
                                                        header: "Tên thiết bị",
                                                        sortable: ""
                                                      })
                                                    ]),
                                                    _: 1
                                                  }, 8, ["value", "selection", "filters", "loading"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            ($setup.thietBi.idKhoaPhong)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                                  _hoisted_73,
                                                  _createVNode(_component_Button, {
                                                    label: 'Thêm ' + $setup.thietBiDaChon.length + ' thiết bị vào khoa/phòng',
                                                    icon: "pi pi-plus-circle",
                                                    onClick: _cache[30] || (_cache[30] = ($event: any) => ($setup.ganThietBiVaoKhoa())),
                                                    loading: $setup.dangGanThietBi,
                                                    disabled: !$setup.thietBi.idNhomThietBi || !$setup.thietBiDaChon.length || $setup.dangGanThietBi || $setup.dangTaiThietBiKhoa
                                                  }, null, 8, ["label", "loading", "disabled"])
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_74, [
                                              _createVNode(_component_DataTable, {
                                                value: $setup.thietBiTrongKhoa,
                                                paginator: true,
                                                stripedRows: "",
                                                showGridlines: "",
                                                rows: 40,
                                                rowsPerPageOptions: [10,25,50],
                                                rowHover: true,
                                                paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                                                globalFilterFields: ['tenThietBi','nhomThietBi'],
                                                currentPageReportTemplate: "Có tất cả {totalRecords} thiết bị",
                                                filters: $setup.filters,
                                                "onUpdate:filters": _cache[31] || (_cache[31] = ($event: any) => (($setup.filters) = $event)),
                                                style: {"font-size":"14px"}
                                              }, {
                                                empty: _withCtx(() => [
                                                  _hoisted_75
                                                ]),
                                                default: _withCtx(() => [
                                                  _createVNode(_component_Column, {
                                                    field: "maThietBi",
                                                    header: "Mã HIS",
                                                    sortable: ""
                                                  }),
                                                  _createVNode(_component_Column, {
                                                    field: "tenThietBi",
                                                    header: "Thiết bị đã gán",
                                                    sortable: ""
                                                  }),
                                                  _createVNode(_component_Column, {
                                                    field: "nhomThietBi",
                                                    header: "Nhóm thiết bị",
                                                    sortable: ""
                                                  }),
                                                  _createVNode(_component_Column, {
                                                    field: "idKhoaPhong",
                                                    header: "Tên khoa phòng",
                                                    sortable: ""
                                                  }, {
                                                    body: _withCtx((slotProps) => [
                                                      _createTextVNode(_toDisplayString($setup.tenKhoaPhong(slotProps.data.idKhoaPhong)), 1)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_Column, {
                                                    field: "id",
                                                    header: "Xóa cài đặt"
                                                  }, {
                                                    body: _withCtx((slotProps) => [
                                                      _createVNode(_component_Button, {
                                                        label: "Xóa",
                                                        icon: "pi pi-trash",
                                                        iconPos: "left",
                                                        onClick: ($event: any) => ($setup.showTemplate(slotProps.data.id)),
                                                        severity: "danger",
                                                        raised: ""
                                                      }, null, 8, ["onClick"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }, 8, ["value", "filters"])
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ($setup.isLoggedIn)
                ? (_openBlock(), _createBlock(_component_TabPanel, {
                    key: 3,
                    header: "4. Phân công dịch vụ"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_NhomDichVuNoiBo, {
                        ref: "nhomDichVuNoiBoRef",
                        khoa: $setup.khoaLamViec,
                        tenKhoa: $setup.tenKhoaLamViec,
                        services: $setup.listDichVu,
                        staff: $setup.listNhanVienKhoaPhongByIdChinh,
                        onBusy: _cache[32] || (_cache[32] = value => $setup.dangLuuCauHinh = value),
                        onChanged: _cache[33] || (_cache[33] = ($event: any) => ($setup.ketQuaChiaGio = null))
                      }, null, 8, ["khoa", "tenKhoa", "services", "staff"]),
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                          _createElementVNode("div", _hoisted_78, [
                            _createVNode(_component_Panel, { header: "Thủ thuật viên chính — phân công trực tiếp" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_79, [
                                  _createVNode(_component_Button, {
                                    label: "Xóa tất cả phân công chính",
                                    icon: "pi pi-trash",
                                    class: "p-button-danger p-button-outlined",
                                    disabled: !$setup.khoaLamViec || $setup.dangXoaTatCa || $setup.dangLuuCauHinh,
                                    onClick: _cache[34] || (_cache[34] = ($event: any) => ($setup.xacNhanXoaTatCa('chinh')))
                                  }, null, 8, ["disabled"])
                                ]),
                                _createElementVNode("div", _hoisted_80, [
                                  _createElementVNode("div", _hoisted_81, [
                                    _createElementVNode("div", _hoisted_82, [
                                      _hoisted_83,
                                      _createVNode(_component_InputText, {
                                        modelValue: $setup.tenKhoaLamViec,
                                        readonly: "",
                                        class: "scope-readonly"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_84, [
                                      _hoisted_85,
                                      _createVNode(_component_BangChon, {
                                        modelValue: $setup.chinhNhanVienIds,
                                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (($setup.chinhNhanVienIds) = $event)),
                                        options: $setup.listNhanVienKhoaPhongByIdChinh,
                                        labelField: "tenNhanVien",
                                        valueField: "nhanVien_Id",
                                        danhTu: "nhân viên chính",
                                        disabled: $setup.dangLuuCauHinh
                                      }, null, 8, ["modelValue", "options", "disabled"])
                                    ]),
                                    _createElementVNode("div", _hoisted_86, [
                                      _hoisted_87,
                                      _createVNode(_component_BangChon, {
                                        modelValue: $setup.chinhDichVuIds,
                                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (($setup.chinhDichVuIds) = $event)),
                                        options: $setup.listDichVu,
                                        labelField: "tenDichVu",
                                        valueField: "dichVu_Id",
                                        disabled: $setup.dangLuuCauHinh
                                      }, null, 8, ["modelValue", "options", "disabled"])
                                    ]),
                                    _createElementVNode("div", _hoisted_88, [
                                      _hoisted_89,
                                      _createVNode(_component_Button, {
                                        label: "Áp dụng nhân viên chính cho dịch vụ đã chọn",
                                        onClick: _cache[37] || (_cache[37] = ($event: any) => ($setup.ganNhanVienHangLoat(1))),
                                        disabled: !$setup.chinhNhanVienIds.length || !$setup.chinhDichVuIds.length || $setup.dangLuuCauHinh
                                      }, null, 8, ["disabled"]),
                                      _hoisted_90,
                                      _createVNode(_component_Dropdown, {
                                        modelValue: $setup.nguoiThucHienChinh.idNguoiThucHien,
                                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (($setup.nguoiThucHienChinh.idNguoiThucHien) = $event)),
                                        options: $setup.listNhanVienKhoaPhongByIdChinh,
                                        optionLabel: "tenNhanVien",
                                        optionValue: "nhanVien_Id",
                                        placeholder: "Tất cả nhân viên chính đã phân công",
                                        showClear: true,
                                        filter: true,
                                        onChange: _cache[39] || (_cache[39] = ($event: any) => ($setup.getListNguoiThucHien($setup.nguoiThucHienChinh.idNguoiThucHien, 1)))
                                      }, null, 8, ["modelValue", "options"])
                                    ]),
                                    _createElementVNode("div", _hoisted_91, [
                                      _createVNode(_component_DataTable, {
                                        value: $setup.listNguoiThucHienChinh,
                                        paginator: true,
                                        stripedRows: "",
                                        showGridlines: "",
                                        rows: 10,
                                        rowsPerPageOptions: [10,25,50],
                                        rowHover: true,
                                        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                                        globalFilterFields: ['tenDichVu'],
                                        currentPageReportTemplate: "Có tất cả {totalRecords} dịch vụ",
                                        filters: $setup.filters,
                                        "onUpdate:filters": _cache[40] || (_cache[40] = ($event: any) => (($setup.filters) = $event)),
                                        style: {"font-size":"14px"}
                                      }, {
                                        empty: _withCtx(() => [
                                          _hoisted_92
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Stt",
                                            headerStyle: "width:3rem"
                                          }, {
                                            body: _withCtx((slotProps) => [
                                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            field: "tenNguoiThucHien",
                                            header: "Nhân viên chính đã lưu",
                                            sortable: ""
                                          }),
                                          _createVNode(_component_Column, {
                                            field: "tenDichVu",
                                            header: "Tên dịch vụ",
                                            sortable: ""
                                          }),
                                          _createVNode(_component_Column, {
                                            field: "idDichVu",
                                            header: "Dịch vụ Id",
                                            sortable: ""
                                          }),
                                          _createVNode(_component_Column, {
                                            field: "id",
                                            header: "Xóa dịch vụ"
                                          }, {
                                            body: _withCtx((slotProps) => [
                                              _createVNode(_component_Button, {
                                                label: "Xóa",
                                                icon: "pi pi-trash",
                                                iconPos: "left",
                                                onClick: ($event: any) => ($setup.deleteDichVuThucHien(slotProps.data.id, 1)),
                                                severity: "danger",
                                                raised: ""
                                              }, null, 8, ["onClick"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["value", "filters"])
                                    ])
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_93, [
                            _createVNode(_component_Panel, { header: "Thủ thuật viên phụ — phân công trực tiếp" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_94, [
                                  _createVNode(_component_Button, {
                                    label: "Xóa tất cả phân công phụ",
                                    icon: "pi pi-trash",
                                    class: "p-button-danger p-button-outlined",
                                    disabled: !$setup.khoaLamViec || $setup.dangXoaTatCa || $setup.dangLuuCauHinh,
                                    onClick: _cache[41] || (_cache[41] = ($event: any) => ($setup.xacNhanXoaTatCa('phu')))
                                  }, null, 8, ["disabled"])
                                ]),
                                _createVNode(_component_Message, {
                                  severity: "info",
                                  closable: false
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_95
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("div", _hoisted_96, [
                                  _createElementVNode("div", _hoisted_97, [
                                    _createElementVNode("div", _hoisted_98, [
                                      _hoisted_99,
                                      _createVNode(_component_InputText, {
                                        modelValue: $setup.tenKhoaLamViec,
                                        readonly: "",
                                        class: "scope-readonly"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_100, [
                                      _hoisted_101,
                                      _createVNode(_component_BangChon, {
                                        modelValue: $setup.phuNhanVienIds,
                                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (($setup.phuNhanVienIds) = $event)),
                                        options: $setup.listNhanVienKhoaPhongByIdPhu,
                                        labelField: "tenNhanVien",
                                        valueField: "nhanVien_Id",
                                        danhTu: "nhân viên phụ",
                                        disabled: $setup.dangLuuCauHinh
                                      }, null, 8, ["modelValue", "options", "disabled"])
                                    ]),
                                    _createElementVNode("div", _hoisted_102, [
                                      _hoisted_103,
                                      _createVNode(_component_BangChon, {
                                        modelValue: $setup.phuDichVuIds,
                                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (($setup.phuDichVuIds) = $event)),
                                        options: $setup.listDichVu,
                                        labelField: "tenDichVu",
                                        valueField: "dichVu_Id",
                                        disabled: $setup.dangLuuCauHinh
                                      }, null, 8, ["modelValue", "options", "disabled"])
                                    ]),
                                    _createElementVNode("div", _hoisted_104, [
                                      _hoisted_105,
                                      _createVNode(_component_Button, {
                                        label: "Áp dụng nhân viên phụ cho dịch vụ đã chọn",
                                        onClick: _cache[44] || (_cache[44] = ($event: any) => ($setup.ganNhanVienHangLoat(2))),
                                        disabled: !$setup.phuNhanVienIds.length || !$setup.phuDichVuIds.length || $setup.dangLuuCauHinh
                                      }, null, 8, ["disabled"]),
                                      _hoisted_106,
                                      _createVNode(_component_Dropdown, {
                                        modelValue: $setup.nguoiThucHienPhu.idNguoiThucHien,
                                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (($setup.nguoiThucHienPhu.idNguoiThucHien) = $event)),
                                        options: $setup.listNhanVienKhoaPhongByIdPhu,
                                        optionLabel: "tenNhanVien",
                                        optionValue: "nhanVien_Id",
                                        placeholder: "Tất cả nhân viên phụ đã phân công",
                                        showClear: true,
                                        filter: true,
                                        onChange: _cache[46] || (_cache[46] = ($event: any) => ($setup.getListNguoiThucHien($setup.nguoiThucHienPhu.idNguoiThucHien, 2)))
                                      }, null, 8, ["modelValue", "options"])
                                    ]),
                                    _createElementVNode("div", _hoisted_107, [
                                      _createVNode(_component_DataTable, {
                                        value: $setup.listNguoiThucHienPhu,
                                        paginator: true,
                                        stripedRows: "",
                                        showGridlines: "",
                                        rows: 10,
                                        rowsPerPageOptions: [10,25,50],
                                        rowHover: true,
                                        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                                        globalFilterFields: ['tenDichVu'],
                                        currentPageReportTemplate: "Có tất cả {totalRecords} dịch vụ",
                                        filters: $setup.filters,
                                        "onUpdate:filters": _cache[47] || (_cache[47] = ($event: any) => (($setup.filters) = $event)),
                                        style: {"font-size":"14px"}
                                      }, {
                                        empty: _withCtx(() => [
                                          _hoisted_108
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Stt",
                                            headerStyle: "width:3rem"
                                          }, {
                                            body: _withCtx((slotProps) => [
                                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            field: "tenNguoiThucHien",
                                            header: "Nhân viên phụ đã lưu",
                                            sortable: ""
                                          }),
                                          _createVNode(_component_Column, {
                                            field: "tenDichVu",
                                            header: "Tên dịch vụ",
                                            sortable: ""
                                          }),
                                          _createVNode(_component_Column, {
                                            field: "idDichVu",
                                            header: "Dịch vụ Id",
                                            sortable: ""
                                          }),
                                          _createVNode(_component_Column, {
                                            field: "id",
                                            header: "Xóa dịch vụ"
                                          }, {
                                            body: _withCtx((slotProps) => [
                                              _createVNode(_component_Button, {
                                                label: "Xóa",
                                                icon: "pi pi-trash",
                                                iconPos: "left",
                                                onClick: ($event: any) => ($setup.deleteDichVuThucHien(slotProps.data.id, 2)),
                                                severity: "danger",
                                                raised: ""
                                              }, null, 8, ["onClick"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["value", "filters"])
                                    ])
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_109, [
                            _createVNode(_component_Panel, { header: "Máy móc thiết bị" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_110, [
                                  _createVNode(_component_Button, {
                                    label: "Xóa tất cả gán thiết bị vào dịch vụ",
                                    icon: "pi pi-trash",
                                    class: "p-button-danger p-button-outlined",
                                    disabled: !$setup.khoaLamViec || $setup.dangXoaTatCa || $setup.dangLuuCauHinh,
                                    onClick: _cache[48] || (_cache[48] = ($event: any) => ($setup.xacNhanXoaTatCa('thietBiDichVu')))
                                  }, null, 8, ["disabled"])
                                ]),
                                _createElementVNode("div", _hoisted_111, [
                                  _createElementVNode("div", _hoisted_112, [
                                    _createElementVNode("div", _hoisted_113, [
                                      _hoisted_114,
                                      _createVNode(_component_Dropdown, {
                                        modelValue: $setup.thietBiDichVu.idNhomThietBi,
                                        "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (($setup.thietBiDichVu.idNhomThietBi) = $event)),
                                        options: $setup.listNhomThietBi,
                                        optionLabel: "tenNhomThietBi",
                                        optionValue: "id",
                                        placeholder: "Chọn nhóm thiết bị",
                                        filter: true,
                                        style: {"height":"35px"},
                                        onChange: _cache[50] || (_cache[50] = ($event: any) => ($setup.taiCauHinhThietBi())),
                                        disabled: $setup.dangLuuCauHinh
                                      }, null, 8, ["modelValue", "options", "disabled"])
                                    ]),
                                    ($setup.thietBiDichVu.idNhomThietBi > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                          _hoisted_116,
                                          _createVNode(_component_InputText, {
                                            modelValue: $setup.tenKhoaLamViec,
                                            readonly: "",
                                            class: "scope-readonly"
                                          }, null, 8, ["modelValue"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    ($setup.thietBiDichVu.idKhoaPhong > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                                          _hoisted_118,
                                          _createVNode(_component_Checkbox, {
                                            modelValue: $setup.apCaNhomThietBi,
                                            "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (($setup.apCaNhomThietBi) = $event)),
                                            binary: true,
                                            disabled: $setup.dangLuuCauHinh
                                          }, null, 8, ["modelValue", "disabled"]),
                                          _hoisted_119,
                                          (!$setup.apCaNhomThietBi)
                                            ? (_openBlock(), _createBlock(_component_BangChon, {
                                                key: 0,
                                                modelValue: $setup.thietBiCauHinhIds,
                                                "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (($setup.thietBiCauHinhIds) = $event)),
                                                options: $setup.listThietBiTheoKhoa,
                                                labelField: "tenThietBi",
                                                valueField: "id",
                                                danhTu: "thiết bị",
                                                disabled: $setup.dangLuuCauHinh
                                              }, null, 8, ["modelValue", "options", "disabled"]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    ($setup.thietBiDichVu.idKhoaPhong > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                          _hoisted_121,
                                          _createVNode(_component_BangChon, {
                                            modelValue: $setup.thietBiDichVuIds,
                                            "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => (($setup.thietBiDichVuIds) = $event)),
                                            options: $setup.listDichVu,
                                            labelField: "tenDichVu",
                                            valueField: "dichVu_Id",
                                            disabled: $setup.dangLuuCauHinh
                                          }, null, 8, ["modelValue", "options", "disabled"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    ($setup.thietBiDichVu.idNhomThietBi > 0 && $setup.thietBiDichVu.idKhoaPhong > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                                          _hoisted_123,
                                          _createVNode(_component_Button, {
                                            label: "Áp dụng thiết bị cho dịch vụ đã chọn",
                                            onClick: _cache[54] || (_cache[54] = ($event: any) => ($setup.ganThietBiHangLoat())),
                                            disabled: !$setup.thietBiDichVuIds.length || (!$setup.apCaNhomThietBi && !$setup.thietBiCauHinhIds.length) || $setup.dangLuuCauHinh
                                          }, null, 8, ["disabled"]),
                                          _createVNode(_component_DataTable, {
                                            value: $setup.nhomThietBiDaGan,
                                            paginator: true,
                                            rows: 10,
                                            showGridlines: ""
                                          }, {
                                            empty: _withCtx(() => [
                                              _hoisted_124
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_Column, {
                                                field: "tenNhomThietBi",
                                                header: "Toàn bộ nhóm"
                                              }),
                                              _createVNode(_component_Column, {
                                                field: "soThietBi",
                                                header: "Thiết bị hiện có"
                                              }),
                                              _createVNode(_component_Column, {
                                                field: "tenDichVu",
                                                header: "Dịch vụ"
                                              }),
                                              _createVNode(_component_Column, { header: "Thao tác" }, {
                                                body: _withCtx((row) => [
                                                  _createVNode(_component_Button, {
                                                    label: "Bỏ áp dụng nhóm",
                                                    onClick: ($event: any) => ($setup.xoaApDungNhom(row.data.id))
                                                  }, null, 8, ["onClick"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["value"]),
                                          _createVNode(_component_Dropdown, {
                                            modelValue: $setup.thietBiDichVu.idDichVu,
                                            "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => (($setup.thietBiDichVu.idDichVu) = $event)),
                                            options: $setup.listDichVu,
                                            optionLabel: "tenDichVu",
                                            optionValue: "dichVu_Id",
                                            placeholder: "Xem thiết bị gán riêng cho dịch vụ",
                                            filter: true,
                                            onChange: _cache[56] || (_cache[56] = ($event: any) => ($setup.getListThietBiDichVu()))
                                          }, null, 8, ["modelValue", "options"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_125, [
                                      _createVNode(_component_DataTable, {
                                        value: $setup.listThietBiDichVu,
                                        paginator: true,
                                        stripedRows: "",
                                        showGridlines: "",
                                        rows: 40,
                                        rowsPerPageOptions: [10,25,50],
                                        rowHover: true,
                                        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                                        globalFilterFields: ['tenThietBi'],
                                        currentPageReportTemplate: "Có tất cả {totalRecords} dịch vụ",
                                        filters: $setup.filters,
                                        "onUpdate:filters": _cache[57] || (_cache[57] = ($event: any) => (($setup.filters) = $event)),
                                        style: {"font-size":"14px"}
                                      }, {
                                        empty: _withCtx(() => [
                                          _hoisted_126
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_Column, {
                                            header: "Stt",
                                            headerStyle: "width:3rem"
                                          }, {
                                            body: _withCtx((slotProps) => [
                                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_Column, {
                                            field: "tenThietBi",
                                            header: "Tên thiết bị",
                                            sortable: ""
                                          }),
                                          _createVNode(_component_Column, {
                                            field: "tenDichVu",
                                            header: "Tên dịch vụ",
                                            sortable: ""
                                          }),
                                          _createVNode(_component_Column, {
                                            field: "id",
                                            header: "Xóa thiết bị"
                                          }, {
                                            body: _withCtx((slotProps) => [
                                              _createVNode(_component_Button, {
                                                label: "Xóa",
                                                icon: "pi pi-trash",
                                                iconPos: "left",
                                                onClick: ($event: any) => ($setup.deleteThietBiDichVu(slotProps.data.id)),
                                                severity: "danger",
                                                raised: ""
                                              }, null, 8, ["onClick"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["value", "filters"])
                                    ])
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_TabPanel, { header: "5. Chấm công và chia lịch" }, {
                default: _withCtx(() => [
                  _createVNode(_component_Panel, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_127, [
                        _createElementVNode("div", _hoisted_128, [
                          _createElementVNode("div", _hoisted_129, [
                            _hoisted_130,
                            _createVNode(_component_InputText, {
                              modelValue: $setup.tenKhoaLamViec,
                              readonly: "",
                              class: "scope-readonly"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_131, [
                            _hoisted_132,
                            _createVNode(_component_Calendar, {
                              id: "date",
                              modelValue: $setup.date,
                              "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => (($setup.date) = $event)),
                              selectionMode: "single",
                              dateFormat: "dd/mm/yy",
                              showButtonBar: true,
                              showIcon: true,
                              manualInput: false,
                              monthNavigator: true,
                              yearNavigator: true,
                              yearRange: "2000:2100",
                              disabled: $setup.loadingExport || $setup.loadingChamCong
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _createElementVNode("div", _hoisted_133, [
                            _hoisted_134,
                            _createVNode(_component_Button, {
                              label: "Xử lý",
                              icon: "pi pi-spinner",
                              iconPos: "left",
                              onClick: _cache[59] || (_cache[59] = ($event: any) => ($setup.chiaGio())),
                              disabled: $setup.loadingExport || !$setup.chamCongDaLuu
                            }, null, 8, ["disabled"])
                          ]),
                          _createElementVNode("div", _hoisted_135, [
                            _createVNode(_component_DataTable, {
                              value: $setup.danhSachChamCong,
                              paginator: true,
                              stripedRows: "",
                              showGridlines: "",
                              rows: 40,
                              rowsPerPageOptions: [10,25,50],
                              rowHover: true,
                              paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                              globalFilterFields: ['tenNhanVien'],
                              currentPageReportTemplate: "Có tất cả {totalRecords} nhân viên",
                              filters: $setup.filters,
                              "onUpdate:filters": _cache[65] || (_cache[65] = ($event: any) => (($setup.filters) = $event)),
                              style: {"font-size":"14px"}
                            }, {
                              header: _withCtx(() => [
                                _createElementVNode("div", _hoisted_136, [
                                  _createElementVNode("span", null, "Sáng: " + _toDisplayString($setup.danhSachChamCong.filter(x => x.coMatSang).length) + " · Chiều: " + _toDisplayString($setup.danhSachChamCong.filter(x => x.coMatChieu).length) + "/" + _toDisplayString($setup.danhSachChamCong.length) + " nhân viên", 1),
                                  _createVNode(_component_Dropdown, {
                                    modelValue: $setup.buoiChamCong,
                                    "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => (($setup.buoiChamCong) = $event)),
                                    options: [{label:'Cả ngày',value:'caNgay'},{label:'Buổi sáng',value:'sang'},{label:'Buổi chiều',value:'chieu'}],
                                    optionLabel: "label",
                                    optionValue: "value",
                                    style: {"width":"150px"}
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_Button, {
                                    label: "Tất cả có mặt",
                                    icon: "pi pi-check-square",
                                    onClick: _cache[61] || (_cache[61] = ($event: any) => ($setup.chamCongTatCa(true))),
                                    disabled: $setup.loadingChamCong || $setup.loadingExport
                                  }, null, 8, ["disabled"]),
                                  _createVNode(_component_Button, {
                                    label: "Tất cả vắng",
                                    onClick: _cache[62] || (_cache[62] = ($event: any) => ($setup.chamCongTatCa(false))),
                                    disabled: $setup.loadingChamCong || $setup.loadingExport
                                  }, null, 8, ["disabled"]),
                                  (!$setup.chamCongDaLuu)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_137, "Chưa lưu thay đổi chấm công"))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              empty: _withCtx(() => [
                                _hoisted_140
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_Column, {
                                  field: "tenNhanVien",
                                  header: "Tên nhân viên",
                                  sortable: ""
                                }),
                                _createVNode(_component_Column, {
                                  field: "coMatSang",
                                  header: "Sáng: 07:00–11:30"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_Checkbox, {
                                      modelValue: slotProps.data.coMatSang,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.coMatSang) = $event),
                                      binary: true,
                                      onChange: _cache[63] || (_cache[63] = ($event: any) => ($setup.doiChamCong())),
                                      disabled: $setup.loadingChamCong || $setup.loadingExport
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                                    _createElementVNode("span", _hoisted_138, _toDisplayString(slotProps.data.coMatSang ? 'Có mặt' : 'Vắng'), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "coMatChieu",
                                  header: "Chiều: 13:30–17:00"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_Checkbox, {
                                      modelValue: slotProps.data.coMatChieu,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.coMatChieu) = $event),
                                      binary: true,
                                      onChange: _cache[64] || (_cache[64] = ($event: any) => ($setup.doiChamCong())),
                                      disabled: $setup.loadingChamCong || $setup.loadingExport
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                                    _createElementVNode("span", _hoisted_139, _toDisplayString(slotProps.data.coMatChieu ? 'Có mặt' : 'Vắng'), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "nguoiCapNhat",
                                  header: "Người lưu"
                                }),
                                _createVNode(_component_Column, { header: "Lần lưu gần nhất" }, {
                                  body: _withCtx((row) => [
                                    _createTextVNode(_toDisplayString(row.data.id ? (row.data.nguoiCapNhat ? $setup.thoiGianUtc(row.data.ngayCapNhat) : 'Đã lưu từ phiên bản cũ') : 'Chưa lưu'), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value", "filters"]),
                            _createVNode(_component_Button, {
                              label: "Lưu chấm công",
                              icon: "pi pi-save",
                              style: {"margin-top":"10px","max-width":"220px"},
                              onClick: _cache[66] || (_cache[66] = ($event: any) => ($setup.luuChamCong())),
                              disabled: !$setup.danhSachChamCong.length || $setup.loadingChamCong
                            }, null, 8, ["disabled"])
                          ]),
                          ($setup.ketQuaChiaGio)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                                _createVNode(_component_Message, {
                                  severity: "info",
                                  closable: false
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Bản lưu #" + _toDisplayString($setup.ketQuaChiaGio.lichSuId) + " · " + _toDisplayString($setup.ketQuaChiaGio.taiKhoanChiaGio) + " · ngày thực hiện " + _toDisplayString($setup.ngayLichSuDangXem) + ". Xuất Excel dùng đúng bản lưu này.", 1)
                                  ]),
                                  _: 1
                                }),
                                ($setup.ketQuaChiaGio.soPhuongAnDaThu)
                                  ? (_openBlock(), _createBlock(_component_Message, {
                                      key: 0,
                                      severity: "info",
                                      closable: false
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Đã chọn phương án tốt nhất trong " + _toDisplayString($setup.ketQuaChiaGio.soPhuongAnDaThu) + " phương án hoàn chỉnh. Trước tối ưu: " + _toDisplayString($setup.ketQuaChiaGio.soChiDinhTruocToiUu) + " chỉ định; sau tối ưu: " + _toDisplayString($setup.ketQuaChiaGio.daXepLich.length) + ". Bảo toàn số người bệnh hoàn tất và được xếp nhiều dịch vụ của lịch nền; ưu tiên tăng chỉ định và giảm thời gian chờ.", 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_142, [
                                  _createElementVNode("h3", null, "Lịch đã chia: " + _toDisplayString($setup.ketQuaChiaGio.daXepLich.length) + "/" + _toDisplayString($setup.ketQuaChiaGio.tongChiDinh) + " chỉ định", 1),
                                  _createVNode(_component_Button, {
                                    label: "Xuất Excel",
                                    icon: "pi pi-file-excel",
                                    onClick: _cache[67] || (_cache[67] = ($event: any) => ($setup.xuatExcelKetQua())),
                                    loading: $setup.dangXuatExcel,
                                    disabled: $setup.dangXuatExcel || $setup.loadingExport
                                  }, null, 8, ["loading", "disabled"])
                                ]),
                                _createVNode(_component_Message, {
                                  severity: "info",
                                  closable: false
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Chỉ xử lý dịch vụ đã duyệt cho " + _toDisplayString($setup.tenKhoaLamViec) + ": " + _toDisplayString($setup.ketQuaChiaGio.tongChiDinh) + " chỉ định. Có " + _toDisplayString($setup.ketQuaChiaGio.soChiDinhNgoaiDanhSachDuyet) + " chỉ định ngoài danh sách duyệt được loại khỏi lần chia này.", 1)
                                  ]),
                                  _: 1
                                }),
                                (!$setup.ketQuaChiaGio.soDichVuCauHinhNhanVienPhu)
                                  ? (_openBlock(), _createBlock(_component_Message, {
                                      key: 1,
                                      severity: "warn",
                                      closable: false
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_143,
                                        _createVNode(_component_Button, {
                                          label: "Cấu hình thủ thuật viên phụ",
                                          class: "p-button-text",
                                          onClick: _cache[68] || (_cache[68] = ($event: any) => ($setup.buocDangMo = 3))
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_Message, {
                                      key: 2,
                                      severity: "info",
                                      closable: false
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Đã chia thủ thuật viên phụ cho " + _toDisplayString($setup.ketQuaChiaGio.soChiDinhDaXepNhanVienPhu) + "/" + _toDisplayString($setup.ketQuaChiaGio.soChiDinhCanNhanVienPhu) + " chỉ định cần người phụ. Các chỉ định chưa đủ cả người chính và phụ cùng rảnh được giữ trong danh sách chưa xếp. ", 1)
                                      ]),
                                      _: 1
                                    })),
                                _createVNode(_component_Message, {
                                  severity: $setup.ketQuaChiaGio.chuaXepLich.length ? 'warn' : 'success',
                                  closable: false
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Nhân viên có mặt: " + _toDisplayString($setup.ketQuaChiaGio.tongNhanVienCoMat) + ". Đã xếp " + _toDisplayString($setup.ketQuaChiaGio.tongPhutDaXep) + "/" + _toDisplayString($setup.ketQuaChiaGio.tongPhutYeuCau) + " phút thực hiện và " + _toDisplayString($setup.ketQuaChiaGio.tongPhutNghiDaXep) + " phút nghỉ tối thiểu của người bệnh (không khóa nhân viên/máy). ", 1),
                                    ($setup.ketQuaChiaGio.chuaXepLich.length)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_144, [
                                          _createTextVNode(" Còn " + _toDisplayString($setup.ketQuaChiaGio.chuaXepLich.length) + " dịch vụ (" + _toDisplayString($setup.ketQuaChiaGio.tongPhutChuaXep) + " phút) chưa thực hiện; ", 1),
                                          ($setup.ketQuaChiaGio.thieuNhanLuc)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_145, "ước tính cần bổ sung ít nhất " + _toDisplayString($setup.ketQuaChiaGio.soNhanVienCanBoSungToiThieu) + " nhân viên theo khối lượng thiếu. Cần xem thêm giới hạn giờ yêu cầu và thiết bị.", 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_146, "Nhân lực hiện tại đáp ứng đủ toàn bộ chỉ định."))
                                  ]),
                                  _: 1
                                }, 8, ["severity"]),
                                _createVNode(_component_KhungChiTiet, {
                                  title: "Lịch theo từng nhân viên",
                                  count: $setup.soNhanVienTrongLich,
                                  modelValue: $setup.hienLichNhanVien,
                                  "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => (($setup.hienLichNhanVien) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_BangLichNhanVien, {
                                      ketQua: $setup.ketQuaChiaGio,
                                      onExported: _cache[69] || (_cache[69] = ($event: any) => ($setup.phienLichSu++))
                                    }, null, 8, ["ketQua"])
                                  ]),
                                  _: 1
                                }, 8, ["count", "modelValue"]),
                                _createVNode(_component_KhungChiTiet, {
                                  title: "Tổng hợp chỉ định từng người bệnh",
                                  count: $setup.ketQuaChiaGio.benhNhans.length,
                                  modelValue: $setup.hienTongHopBenhNhan,
                                  "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => (($setup.hienTongHopBenhNhan) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DataTable, {
                                      value: $setup.ketQuaChiaGio.benhNhans,
                                      paginator: true,
                                      rows: 10,
                                      stripedRows: "",
                                      showGridlines: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          field: "tenBenhNhan",
                                          header: "Người bệnh",
                                          sortable: ""
                                        }),
                                        _createVNode(_component_Column, {
                                          field: "tongChiDinh",
                                          header: "Tổng chỉ định",
                                          sortable: ""
                                        }),
                                        _createVNode(_component_Column, {
                                          field: "daXep",
                                          header: "Đã xếp",
                                          sortable: ""
                                        }),
                                        _createVNode(_component_Column, {
                                          field: "chuaXep",
                                          header: "Chưa xếp",
                                          sortable: ""
                                        }),
                                        _createVNode(_component_Column, { header: "Chi tiết" }, {
                                          body: _withCtx((row) => [
                                            _createVNode(_component_Button, {
                                              label: "Xem dịch vụ",
                                              class: "p-button-text",
                                              onClick: ($event: any) => ($setup.xemDichVuBenhNhan(row.data.khoaBenhNhan))
                                            }, null, 8, ["onClick"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["value"])
                                  ]),
                                  _: 1
                                }, 8, ["count", "modelValue"]),
                                ($setup.benhNhanDangXem)
                                  ? (_openBlock(), _createBlock(_component_Button, {
                                      key: 3,
                                      label: "Xem lại toàn bộ người bệnh",
                                      onClick: _cache[72] || (_cache[72] = ($event: any) => ($setup.benhNhanDangXem = ''))
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_KhungChiTiet, {
                                  title: "Dịch vụ đã xếp giờ",
                                  count: $setup.lichDangXem.length,
                                  modelValue: $setup.hienLichDaXep,
                                  "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => (($setup.hienLichDaXep) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DataTable, {
                                      value: $setup.lichDangXem,
                                      paginator: true,
                                      rows: 25,
                                      stripedRows: "",
                                      showGridlines: "",
                                      tableStyle: {minWidth:'1450px'}
                                    }, {
                                      empty: _withCtx(() => [
                                        _hoisted_147
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          field: "dichVuYeuCauId",
                                          header: "Mã chỉ định"
                                        }),
                                        _createVNode(_component_Column, { header: "STT" }, {
                                          body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          field: "tenBenhNhan",
                                          header: "Người bệnh",
                                          sortable: ""
                                        }),
                                        _createVNode(_component_Column, {
                                          field: "maYTe",
                                          header: "Mã y tế"
                                        }),
                                        _createVNode(_component_Column, {
                                          field: "tenDichVu",
                                          header: "Dịch vụ",
                                          sortable: ""
                                        }),
                                        _createVNode(_component_Column, {
                                          field: "thoiGianThucHien",
                                          header: "Số phút"
                                        }),
                                        _createVNode(_component_Column, {
                                          field: "thoiGianNghi",
                                          header: "BN nghỉ tối thiểu"
                                        }),
                                        _createVNode(_component_Column, { header: "Giờ yêu cầu" }, {
                                          body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString($setup.formatHour(slotProps.data.thoiGianYeuCau)), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          field: "tenNhanVien",
                                          header: "Thủ thuật viên chính",
                                          sortable: ""
                                        }),
                                        _createVNode(_component_Column, {
                                          field: "tenNhanVienPhu",
                                          header: "Thủ thuật viên phụ"
                                        }, {
                                          body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(slotProps.data.tenNhanVienPhu || 'Không cấu hình người phụ'), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          field: "tenThietBi",
                                          header: "Thiết bị thực hiện"
                                        }),
                                        _createVNode(_component_Column, { header: "Bắt đầu" }, {
                                          body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString($setup.formatHour(slotProps.data.thoiGianBatDau)), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_Column, { header: "Kết thúc" }, {
                                          body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString($setup.formatHour(slotProps.data.thoiGianKetThuc)), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["value"])
                                  ]),
                                  _: 1
                                }, 8, ["count", "modelValue"]),
                                ($setup.ketQuaChiaGio.chuaXepLich.length)
                                  ? (_openBlock(), _createBlock(_component_Message, {
                                      key: 4,
                                      severity: "warn",
                                      closable: false
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Có " + _toDisplayString($setup.ketQuaChiaGio.chuaXepLich.length) + " chỉ định chưa thể xếp trong giờ làm việc. ", 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_KhungChiTiet, {
                                  title: "Chỉ định chưa chia được",
                                  count: $setup.chuaXepDangXem.length,
                                  modelValue: $setup.hienLichChuaXep,
                                  "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => (($setup.hienLichChuaXep) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DataTable, {
                                      value: $setup.chuaXepDangXem,
                                      paginator: true,
                                      rows: 20,
                                      stripedRows: "",
                                      showGridlines: "",
                                      tableStyle: {minWidth:'850px'}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          field: "dichVuYeuCauId",
                                          header: "Mã chỉ định"
                                        }),
                                        _createVNode(_component_Column, {
                                          field: "tenBenhNhan",
                                          header: "Người bệnh"
                                        }),
                                        _createVNode(_component_Column, {
                                          field: "tenDichVu",
                                          header: "Dịch vụ"
                                        }),
                                        _createVNode(_component_Column, {
                                          field: "thoiGianThucHien",
                                          header: "Số phút"
                                        }),
                                        _createVNode(_component_Column, {
                                          field: "thoiGianNghi",
                                          header: "BN nghỉ tối thiểu"
                                        }),
                                        _createVNode(_component_Column, {
                                          field: "lyDo",
                                          header: "Lý do"
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["value"])
                                  ]),
                                  _: 1
                                }, 8, ["count", "modelValue"])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_148, [
                            _createVNode(_component_KhungChiTiet, {
                              title: "Lịch sử chia giờ và xuất file",
                              modelValue: $setup.hienLichSu,
                              "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => (($setup.hienLichSu) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_LichSuChiaGio, {
                                  ref: "lichSuRef",
                                  khoa: $setup.khoaLamViec,
                                  ngay: $setup.date,
                                  refreshKey: $setup.phienLichSu,
                                  onOpen: $setup.moLichSuChiaGio
                                }, null, 8, ["khoa", "ngay", "refreshKey", "onOpen"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_149, [
                            _createVNode(_component_Dialog, {
                              class: "workflow-dialog",
                              header: "Đang xử lý",
                              visible: $setup.loadingBar,
                              "onUpdate:visible": _cache[76] || (_cache[76] = ($event: any) => (($setup.loadingBar) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_150, [
                                  _hoisted_151,
                                  _createVNode(_component_ProgressBar, {
                                    mode: "indeterminate",
                                    style: {"height":".3em"}
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["visible"]),
                            _createVNode(_component_ConfirmDialog, { class: "workflow-dialog" })
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["activeIndex"])
        ])),
    _createElementVNode("div", _hoisted_152, [
      _createElementVNode("div", _hoisted_153, [
        _createElementVNode("div", _hoisted_154, [
          _createVNode(_component_ConfirmDialog, {
            class: "workflow-dialog",
            group: "templating"
          }, {
            message: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_155, [
                _createElementVNode("p", null, _toDisplayString(slotProps.message.message), 1)
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}